import { type FC, useCallback } from 'react';
import { Form } from 'react-bootstrap';

import CodeMirrorHTML from '@editor2/components/CodeMirrorHTML';
import { useDebounceProtectedState } from '@editor2/hooks/useDebounceProtectedState';
import { contextualInfoStyle } from './styles';

interface Props {
	index: number;
	contextual_info: string[];
	onChange: (_) => void;
}

const DatasetContextualInfo: FC<Props> = (props) => {
	const { index, contextual_info: contextualInfo, onChange } = props;

	// Mapper wraps string value in an object for hook consistency
	const valueMapper = useCallback((value: string) => ({ value }), []);

	const [state, handleLocalChange] = useDebounceProtectedState(contextualInfo[index], valueMapper);

	const onContextualInfoChange = (value: string) => {
		handleLocalChange({ value });

		const updatedContextualInfo = [
			...contextualInfo.slice(0, index),
			value,
			...contextualInfo.slice(index + 1)
		];

		onChange({ contextual_info: updatedContextualInfo });
	};

	return (
		<Form.Group className={contextualInfoStyle}>
			<Form.Label>Dataset {index + 1}</Form.Label>
			<div className="contextualInfoInput">
				<CodeMirrorHTML
					value={state.value}
					showTips={false}
					options={{ placeholder: 'Dataset contextual info' }}
					onChange={(value) => onContextualInfoChange(value)}
				/>
			</div>
		</Form.Group>
	);
};

export default DatasetContextualInfo;
